import React, { useEffect, useState } from "react";
import { Grid, Button, Typography, IconButton, Box } from "@material-ui/core";
import InputField from "src/components/ui-components/InputField";
import SelectField from "src/components/ui-components/SelectField";
import SwitchField from "src/components/ui-components/SwitchField";
import { AddCircle, Delete } from "@material-ui/icons";
import { FieldArray } from "formik";
import SubMenuFilterValueCreateEdit from "./SubMenuFilterValueCreateEdit";
import { getWebMethodsList } from "./ConnectionService";
import AlertMessage from "src/components/ui-components/AlertMessage";

const defaultPageFilterValue = {
  pageFilterValueKey: null,
  pageFilterKey: "",
  pageFilterValueName: "",
  pageFilterValue: "",
  sortOrder: 0,
  isDefault: false,
};

const SubMenuFilterCreateEdit = ({ pages, index, indexFilter }) => {
  const [webMethodsData, setWebMethodsData] = useState([]);
  const getWebMethods = () => {
    try {
      getWebMethodsList().then((res) => {
        setWebMethodsData(res);
      });
    } catch (err) {
      AlertMessage({ type: "error", msg: err.title });
    }
  };
  useEffect(() => {
    getWebMethods();
  }, []);
  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={6}>
          <InputField
            label="Sub Menu Filter Name"
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterName`}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Sub Menu Filter Type"
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterType`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <SelectField
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterWebMethodKey`}
            label="Web Method"
            data={webMethodsData}
            dataTextField="webMethodName"
            dataValueField="webMethodKey"
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Sub Menu Filter Fields Separator"
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterFieldsSeparater`}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Sort Order"
            name={`pages.${index}.pageFilter.${indexFilter}.sortOrder`}
          />
        </Grid>
        <Grid item xs={3}>
          <SwitchField
            name={`pages.${index}.pageFilter.${indexFilter}.hasConfigurableWidgets`}
            label="Has Configurable widgets"
            // sx={{ marginBottom: 5 }}
          />
        </Grid>
        <Grid item xs={3}>
          <SwitchField
            name={`pages.${index}.pageFilter.${indexFilter}.isEnabled`}
            label="Is Enabled"
            // sx={{ marginBottom: 5 }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 8 }}>
        <FieldArray
          name={`pages.${index}.pageFilter.${indexFilter}.pageFilterValues`}
        >
          {({ push, remove }) => (
            <>
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                xl={12}
                sx={{
                  textAlign: "right",
                  paddingRight: 2,
                  padding: 2,
                }}
              >
                <>
                  <Button
                    sx={{
                      background:
                        "linear-gradient(to bottom, #09735e, #09735e)",
                      minWidth: 100,
                      marginRight: 1,
                    }}
                    variant="contained"
                    type="button"
                    startIcon={<AddCircle />}
                    onClick={() =>
                      push({
                        ...defaultPageFilterValue,
                        sortOrder:
                          pages[index].pageFilter[indexFilter].pageFilterValues
                            .length + 1,
                      })
                    }
                  >
                    Add Filter Value
                  </Button>
                </>
              </Grid>
              {pages[index]?.pageFilter[indexFilter]?.pageFilterValues?.map(
                (pageFilterValue, indexFilterValue) => (
                  <Box key={indexFilterValue} marginBottom={5}>
                    <React.Fragment key={indexFilterValue}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ marginBottom: 1 }}
                      >
                        Sub Menu Filter Value {indexFilterValue + 1}
                        <IconButton
                          type="button"
                          onClick={() => remove(indexFilterValue)}
                        >
                          <Delete style={{ fontSize: 20 }} />
                        </IconButton>
                      </Typography>
                      <SubMenuFilterValueCreateEdit
                        pages={pages}
                        index={index}
                        indexFilter={indexFilter}
                        indexFilterValue={indexFilterValue}
                      />
                    </React.Fragment>
                  </Box>
                )
              )}
            </>
          )}
        </FieldArray>
      </Grid>
    </>
  );
};

export default SubMenuFilterCreateEdit;
